import isEqual from 'lodash/isEqual'
import React, { useRef, useState } from 'react'

import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'
import { NotEmptyValidationV2 } from '@Shared/Components/Forms/Validations/NotEmptyValidation'
import { PasswordValidation } from '@Shared/Components/Forms/Validations/PasswordValidation'
import { TextInput, useTextInputActionRef } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

export const ClubResetPassword = () => {
  const { resetPassword, setModalState } = useClub()
  const { t } = useTranslation()
  const passwordActionRef = useTextInputActionRef()
  const [password, setPassword] = useState('')
  const passwordRef = useRef(password)
  const passwordRepeatActionRef = useTextInputActionRef()
  const [passwordRepeat, setPasswordRepeat] = useState('')
  const [genericError, setGenericError] = useState<string | undefined>()

  return (
    <form onSubmit={async (e) => {
      e.preventDefault()
      e.stopPropagation()
      passwordActionRef.current?.touch()
      const isPasswordValid = passwordActionRef.current?.validate()
      passwordRepeatActionRef.current?.touch()
      const isPasswordRepeatValid = passwordRepeatActionRef.current?.validate()
      if (!isPasswordValid || !isPasswordRepeatValid || !isEqual(password, passwordRepeat)) {
        return
      }
      const errorString = await resetPassword(password)
      if (errorString) {
        setGenericError(errorString)
        return
      }
      setModalState('SIGN_IN')
    }}
    >
      <p className={styles.bigLabel}>{t('common:TRENDHIMCLUB_CREATE_A_NEW_PASSWORD')}</p>
      <p>{t('common:TRENDHIMCLUB_ENTER_EMAIL_NEW_PASSWORD')}</p>
      <TextInput
        actionRef={passwordActionRef}
        autoFocus
        className={styles.formElementGab}
        id="ClubModal_Signup_Password"
        label={t('common:PASSWORD')}
        onChange={(value) => {
          passwordRef.current = value
          setPassword(value)
        }}
        type="password"
        validations={[NotEmptyValidationV2, PasswordValidation]}
        value={password}
      />

      <TextInput
        actionRef={passwordRepeatActionRef}
        className={styles.formElementGab}
        id="ClubModal_Signup_Password_Repeat"
        label={t('common:REPEAT_PASSWORD')}
        onChange={value => setPasswordRepeat(value)}
        type="password"
        validations={[
          NotEmptyValidationV2, PasswordValidation, v => ({
            errorMessage: 'common:THE_2_PASSWORD_ARE_NOT_SAME',
            success: v === passwordRef.current,
          }),
        ]}
        value={passwordRepeat}
      />

      <Button
        className={styles.nextButton}
        color="black"
        style={{ margin: '0' }}
        type="submit"
      >
        {t('common:CA_SAVE_PASSWORD')}
      </Button>
      {genericError && <p className={styles.error}>{t(genericError)}</p>}
    </form>
  )
}

